import config from '@/config';
import { DOMAIN_CONNECT_PRODUCT_TYPES } from '@/types';
export const getSubDomainUrl = (productTeam) => {
    switch (productTeam) {
        case DOMAIN_CONNECT_PRODUCT_TYPES.FUNNELWEBSITE:
            return config.FUNNEL_SUB_DOMAIN_URL;
        case DOMAIN_CONNECT_PRODUCT_TYPES.MEMBERSHIP:
            return config.MEMBERSHIP_SUB_DOMAIN_URL;
        case DOMAIN_CONNECT_PRODUCT_TYPES.APIDOMIAN:
            return config.API_DOMAIN_SUB_DOMAIN_URL;
        case DOMAIN_CONNECT_PRODUCT_TYPES.WHITELABELED:
            return config.WHITE_LABELED_SUB_DOMAIN_URL;
        case DOMAIN_CONNECT_PRODUCT_TYPES.DOMAINBRANDING:
            return config.DOMAIN_BRANDED_SUB_DOMAIN_URL;
        default:
            return config.FUNNEL_SUB_DOMAIN_URL;
    }
};
export const getRootDomainIP = (productTeam) => {
    switch (productTeam) {
        case DOMAIN_CONNECT_PRODUCT_TYPES.FUNNELWEBSITE:
            return config.FUNNEL_ROOT_DOMAIN_IP_ADDRESS;
        case DOMAIN_CONNECT_PRODUCT_TYPES.MEMBERSHIP:
            return config.MEMBERSHIP_ROOT_DOMAIN_IP_ADDRESS;
        case DOMAIN_CONNECT_PRODUCT_TYPES.WORDPRESS:
            return config.WORDPRESS_ROOT_DOMAIN_IP_ADDRESS;
        default:
            return config.FUNNEL_ROOT_DOMAIN_IP_ADDRESS;
    }
};
export const getHelpVideoLink = (productTeam) => {
    switch (productTeam) {
        case DOMAIN_CONNECT_PRODUCT_TYPES.FUNNELWEBSITE:
            return 'https://www.youtube.com/watch?v=Qg1hI_hhWY0&amp;ab_channel=LeadConnector';
        default:
            return 'https://www.youtube.com/watch?v=Qg1hI_hhWY0&amp;ab_channel=LeadConnector';
    }
};
